import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { ASSET_PREFIX } from 'utils/constants';
import { HeaderIconWithBadge } from './HeaderIconWithBadge';

export const AccountHeaderIcon = observer(({ white }: { white?: boolean }) => {
  const { claimablePrizesCount } = useUserStore();

  return (
    <HeaderIconWithBadge
      iconImage={`${ASSET_PREFIX}/images/header/account-menu-icon${
        white ? '-white' : ''
      }.svg`}
      iconImageAlt="account icon"
      badgeNumber={claimablePrizesCount}
    />
  );
});
